/**
 * GT Header — close button inside mobile menu drawer.
 */
(function () {
  'use strict';

  function bindCloseButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gt-menu-drawer-close]').forEach(function (button) {
      if (button.dataset.gtMenuDrawerCloseBound === 'true') return;
      button.dataset.gtMenuDrawerCloseBound = 'true';

      button.addEventListener('click', function () {
        var headerDrawer = button.closest('header-drawer');
        if (!headerDrawer) return;

        var summary = headerDrawer.querySelector('.menu-drawer-container > summary');
        if (summary) summary.click();
      });
    });
  }

  function initAll() {
    bindCloseButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (target) bindCloseButtons(target);
  });
})();
